import React, { useState } from 'react';
// @ts-ignore
import Slider from 'react-slick';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import '../Assets/css/FlotaHome.css';
import { NextArrow, PrevArrow } from "./ui/CustomArrow";

import Flota from '../Assets/img/flota/Sprinter.jpeg';
import Flota2 from '../Assets/img/flota/web_FLLV63.jpg';
import Flota3 from '../Assets/img/flota/web_GDGH29.jpg';
import Flota4 from '../Assets/img/flota/web_GFBV53.jpg';
import Flota5 from '../Assets/img/flota/web_GGYC43.jpg';
import Flota6 from '../Assets/img/flota/web_GLZH79.jpg';


import pdf from '../Assets/img/flota/Sprinter.pdf';
import pdf2 from '../Assets/img/flota/Viaggio1050[FLLV63].pdf';
import pdf3 from '../Assets/img/flota/Paradiso1200[GDGH29].pdf';
import pdf4 from '../Assets/img/flota/Paradiso1200[GFBV53].pdf';
import pdf5 from '../Assets/img/flota/Viaggio900[GGYC43].pdf';
import pdf6 from '../Assets/img/flota/Paradiso1200[GLZH79].pdf';

const FlotaArray = [
    { imagen: Flota, url: pdf, name: 'Sprinter' },
    { imagen: Flota2, url: pdf2, name: 'Viaggio 1050' },
    { imagen: Flota3, url: pdf3, name: 'Paradiso 1200' },
    { imagen: Flota4, url: pdf4, name: 'Paradiso 1200' },
    { imagen: Flota5, url: pdf5, name: 'Viaggio 900' },
    { imagen: Flota6, url: pdf6, name: 'Paradiso 1200' },
];

export const Flotabuses = () => {

    const [buses, setBuses] = useState(FlotaArray);

    const sliderSettings = {
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 2000,
        nextArrow: <NextArrow />,
        prevArrow: <PrevArrow />,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 2,
                    infinite: true,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };

    return (
        <section className="flota-container" id="flota">
            <div className="container">
                <h1
                    style={{
                        textAlign: 'center',
                        fontSize: '50px',
                        paddingBottom: '10px',
                        fontWeight: 'bold'
                    }}
                >
                    Nuestra Flota
                </h1>

                <div className="slider-flota-container">
                    <Slider {...sliderSettings}>
                        {buses.map((flota, index) => (
                            <div className="cubo-flota" key={index}>
                                <a href={flota.url} target="_blank" rel="noopener noreferrer">
                                    <div className="flota-image-container">
                                        <img
                                            className="cliente-logo"
                                            src={flota.imagen}
                                            alt={flota.imagen}
                                        />
                                        <h3 className="flota-name">{flota.name}</h3>
                                    </div>
                                </a>
                            </div>
                        ))}
                    </Slider>
                </div>
            </div>
        </section>
    );
};

